import { render, staticRenderFns } from "./canny.vue?vue&type=template&id=713daf14"
import script from "./canny.vue?vue&type=script&lang=js"
export * from "./canny.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports